export const loanQuoteSeoTitle = 'Get your quote'
export const loanQuoteChangeSeoTitle = `Don't forget your quote!`

export const loanApplicationSeoTitle = 'Your loan application'
export const loanApplicationChangeSeoTitle = 'Complete your loan application'
